import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 20px 20px 10px;
  width: 100%;

  .widget-name {
    font-size: 16px;
    margin-bottom: 32px;
  }

  .widget-container {
    display: flex;
    justify-content: flex-start;
  }

  .chart-section {
    flex: 1;
    max-width: 260px;
    margin: 0 auto;
  }

  .knob {
    box-shadow: 10px 5px 5px red;
  }

  .info-cards {
    flex: 0 0 50%;
  }

  .chart-container {
    width: 100%;
  }

  .total-label {
    text-align: right;
    font-size: 14px;
    color: ${(props) => props.theme.colors.text};
    margin-top: 8px;

    .total-text {
      font-family: 'ManropeRegular';
    }

    .total-value {
      font-family: 'ManropeExtraBold';
    }
  }
`;

export default { Wrapper };
